<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
// import VueRouter from "vue-router";
import { isNavigationFailure, NavigationFailureType } from "vue-router";
// const { ,  } = VueRouter;

export default {
  name: "OidcCallback",
  methods: {
    ...mapActions("oidcStore", ["oidcSignInCallback"]),
  },
  created() {
    this.oidcSignInCallback()
      .then((redirectPath) => {
        this.$router.push(redirectPath).catch((failure) => {
          if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
            console.log("redirected failure: ", failure);
          }
        });
      })
      .catch((err) => {
        console.error(err);
        this.$router.push("/").catch((failure) => {
          if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
            console.log("redirected failure: ", failure);
          }
        }); // Handle errors any way you want
      });
  },
};
</script>
